module.exports = "<p>{{vm.msg}}</p>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/components/input-validation/input-validation.jade
// module id = 239
// module chunks = 0